import { validateSPBTableInterface } from "../../../../../helpers/validateSPBTableInterface";
import { addObjectToScene } from "../../../../addObjectToScene";
import { setActiveCalcValue } from "../../../../calculator";
import { changeMaterialColor, changeObjColor } from "../../../../changeMaterialColor";
import { setUpViewPort } from "../../../../setUpCamera";
import { POSITIONS_MAPS } from "../../../constants";
import { getTableSize, hideAndRemove, hideAndRemoveInArr, showHideChildrenByNames } from "../../../helpers";
import { toggleMultiSceneObject, toggleSceneObject, toggleSingleSceneObject } from "../../../togglers";
import { updateTableDependencies } from "../../updateTableDependencies";
import { changeElektropanel } from "../up/up";
export const changeTableSize = (type, value) => {
    if (!value) {
        console.warn("Не передано значение для изменения стола:", value);
        return;
    }

    value = Number(value);

    if (type === "width") {
        servObj.tableSize.tableWidth.current = value;
    } else if (type === "depth") {
        servObj.tableSize.tableDepth.current = value;
    } else {
        console.warn("Неизвестный тип параметра:", type);
        return;
    }

    let visibleChildren = null;
    if (servObj.redactorModeObject?.userData?.visibleChildren?.length) {
        visibleChildren = servObj.redactorModeObject.userData.visibleChildren;
    }
    const isWidthEqual2000 = servObj.tableSize.tableWidth.current == 2000;
    const isDepthEqual500 = servObj.tableSize.tableDepth.current == 500;
    const { folderName } = servObj.redactorModeObject.userData.loadData;
    const isStoyka = folderName === "stoyki_podkatnie";
    const tempName = isStoyka ? `stoyka__${servObj.tempName}` : servObj.tempName || "bazovii__osnovanie";
    let name = `${tempName}__${servObj.tableSize.tableWidth.current}x${servObj.tableSize.tableDepth.current}`;

    // ДЛЯ СТОЛА СПБ
    if (tempName === "spb__osnovanie") {
        validateSPBTableInterface();
        if (isWidthEqual2000 && isDepthEqual500) {
            name = `${tempName}__${servObj.tableSize.tableWidth.current}x700`;
        }
    }

    // Чистим building от уже добавленных объектов
    if (servObj.redactorModeObject && servObj.building._all.length) {
        servObj.building._all = servObj.building._all.filter((table) => table.uuid !== servObj.redactorModeObject.uuid);
        servObj.building._objects = servObj.building._objects.filter(
            (table) => table.uuid !== servObj.redactorModeObject.uuid,
        );
    }
    const tableName = tempName.split("__")[0];
    const stoykaName = tempName;
    const calc_table_name = `${isStoyka ? stoykaName : tableName}__${servObj.tableSize.tableWidth.current}x${servObj.tableSize.tableDepth.current}`;
    addObjectToScene(
        {
            objectName: name,
        },
        calc_table_name,
        true,
    );
    updateTableDependencies(type, value, visibleChildren);
    const activeTable = [servObj.redactorModeObject];
    changeObjColor(activeTable);
};
export const changeTableColor = (matName, color) => {
    const tableObj = servObj.redactorModeObject;

    // ---------- Проверка входных данных ----------
    if (typeof matName !== "string" || !matName.trim()) {
        console.error("❌ changeTableColor: некорректное имя материала:", matName);
        return;
    }

    if (!color) {
        console.error("❌ changeTableColor: цвет не задан:", color);
        return;
    }

    // ---------- Проверка HEX ----------
    const isValidHex = (val) => typeof val === "string" && /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/i.test(val.trim());

    // ---------- Приведение к нужному виду ----------
    let parsedColor = color;

    // Если это строка с несколькими цветами — превращаем в массив
    if (typeof color === "string" && color.includes("|")) {
        parsedColor = color
            .split("|")
            .map((c) => c.trim())
            .filter(isValidHex);

        if (!parsedColor.length) {
            console.error("❌ changeTableColor: строка color с '|' не содержит корректных HEX значений", color);
            return;
        }
    }

    // Если массив — фильтруем и ограничиваем двумя цветами
    if (Array.isArray(parsedColor)) {
        parsedColor = parsedColor.filter(isValidHex).slice(0, 2);
        if (!parsedColor.length) {
            console.error("❌ changeTableColor: массив color не содержит корректных HEX значений", color);
            return;
        }
    }

    // ---------- Применяем цвет ----------
    const applyColorToObj = (obj) => {
        if (obj && typeof obj.traverse === "function") {
            changeMaterialColor(obj, matName, parsedColor);
        }
    };

    applyColorToObj(tableObj);

    Object.keys(servObj).forEach((key) => {
        if (key.startsWith("active") && Array.isArray(servObj[key])) {
            servObj[key].forEach((item) => applyColorToObj(item));
        }
    });

    // ---------- Сохраняем результат ----------
    servObj.tableColor[matName] = {
        ...(servObj.tableColor[matName] || {}),
        current: parsedColor,
    };
};

export const changeTableCover = (value, isChecked) => {
    // Базовые имена материалов
    const baseNames = {
        polikarb: "dopolnitelnoe_pokritie_stoleshnitsi__polikarbon",
        zink: "dopolnitelnoe_pokritie_stoleshnitsi__otsinkovka",
        metall2mm: "dopolnitelnoe_pokritie_stoleshnitsi__metall_2",
        metall6mm: "dopolnitelnoe_pokritie_stoleshnitsi__metall_6",
    };

    // Получаем размер стола
    const tableSize = getTableSize();

    // Формируем полные имена материалов
    const fullNames = Object.fromEntries(
        Object.entries(baseNames).map(([key, baseName]) => [key, `${baseName}__${tableSize}`]),
    );

    // Выбираем имя по value
    const name = fullNames[value];

    if (!name) {
        console.warn("Некорректный value", value);
        return;
    }
    if (!servObj.redactorModeObject.name.includes("ostrov")) {
        toggleSceneObject({
            allObjects: servObj.allTableCover,
            activeArray: servObj.activeTableCover,
            name,
            isChecked,
            filterActiveFn: () => {},
            position: {
                y: 10,
            },
        });
    } else {
        // Если это "Остров"
        // Для переднего стола
        toggleSceneObject({
            allObjects: servObj.allTableCover,
            activeArray: servObj.activeTableCover,
            name,
            isChecked,
            filterActiveFn: () => {},
            // В первом случае всегда оставляем пустым, иначе выполнение будет множиться
            position: {
                y: 10,
                z: POSITIONS_MAPS.ostrovPlacementMapPos.front.z,
            },
            userData: {
                placement: "front",
                value,
            },
        });

        // Для заднего стола
        toggleSceneObject({
            allObjects: servObj.allTableCover,
            activeArray: servObj.activeTableCover,
            name,
            isChecked,
            filterActiveFn: (el) => el.userData.value === value,
            position: {
                y: 10,
                z: POSITIONS_MAPS.ostrovPlacementMapPos.back.z,
            },
            userData: {
                placement: "back",
                value,
            },
        });
    }

    // Если есть электропанель - вызываем её повторно, чтобы поменять y-позицию, если необходимо
    if (servObj.activeElektropanel.length) {
        changeElektropanel(true);
    }
};
export const changeTableStops = (value, isChecked) => {
    if (!value) {
        console.warn("Не передано значение для изменения стола:", value);
        return;
    }
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const prefix = isOstrov ? "ostrov__ogranichitel" : "ogranichitel";
    if (!servObj.tableSize.tableWidth.current) {
        console.warn("Ширина стола не определена!");
    }
    let objName = null;
    if (value === "zadnii") {
        objName = `${prefix}_${value}__stol__${servObj.tableSize.tableWidth.current}`;
    } else if (value === "bokovoi") {
        objName = `${prefix}_${value}__stol__${servObj.tableSize.tableWidth.current}x${servObj.tableSize.tableDepth.current}`;
    }
    if (!objName) {
        console.warn("Объект не найден", objName);
        return;
    }
    toggleMultiSceneObject({
        allObjects: servObj.allTableStops,
        activeArray: servObj.activeTableStops,
        name: objName,
        isChecked,
        valueType: value,
        position: {
            y: 10,
        },
        userData: {
            originName: objName,
        },
        ...(isOstrov
            ? {}
            : {
                  excludes: ["ostrov"],
              }),
    });
};
export const changeCornerTable = (value, isChecked, placement = null) => {
    const name = `uglovoy_stol__${value}x500`;
    if (placement === "front") {
        const sideWrap = document.querySelector(".corner_table_side_wrap__table_front");
        const sideInput = sideWrap.querySelector('input[name="corner_table_side__table_front"]:checked') || null;
        const side = sideInput?.value || "right";
        toggleSceneObject({
            allObjects: servObj.allCornerTable,
            activeArray: servObj.activeCornerTable,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.userData.value === value || el.userData.placement === "front") {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: {
                y: 10,
                x: POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current],
                z:
                    POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current] +
                    POSITIONS_MAPS.ostrovPlacementMapPos.front.z,
            },
            userData: {
                type: side,
                position: "bottom",
                placement: "front",
            },
        });
    } else if (placement === "back") {
        const sideWrap = document.querySelector(".corner_table_side_wrap__table_back");
        const sideInput = sideWrap.querySelector('input[name="corner_table_side__table_back"]:checked') || null;
        const side = sideInput?.value || "right";
        toggleSceneObject({
            allObjects: servObj.allCornerTable,
            activeArray: servObj.activeCornerTable,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.userData.value === value || el.userData.placement === "back") {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: {
                y: 10,
                x: POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current],
                z:
                    -POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current] +
                    POSITIONS_MAPS.ostrovPlacementMapPos.back.z,
            },
            userData: {
                type: side,
                position: "bottom",
                placement: "back",
            },
        });
    } else {
        const sideWrap = document.querySelector(".corner_table_side_wrap");
        const sideInput = sideWrap.querySelector('input[name="corner_table_side"]:checked') || null;
        const side = sideInput?.value || "right";
        toggleSingleSceneObject({
            allObjects: servObj.allCornerTable,
            activeArray: servObj.activeCornerTable,
            name,
            isChecked,
            filterActiveFn: () => {},
            position: {
                y: 10,
                x: POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current],
            },
            userData: {
                type: side,
                position: "bottom",
            },
        });
    }
};
export const changeCornerTableSide = (placement = null) => {
    if (!servObj.activeCornerTable.length > 0) return;
    if (placement === null) {
        const sideInput = document.querySelector('input[name="corner_table_side"]:checked') || null;
        const side = sideInput?.value || "right";
        servObj.activeCornerTable[0].position.x =
            POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current];
        servObj.activeCornerTable[0].position.z =
            POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current];
    } else if (placement === "front") {
        const sideInput = document.querySelector('input[name="corner_table_side__table_front"]:checked') || null;
        const side = sideInput?.value || "right";
        const frontCornerTable = servObj.activeCornerTable.find((el) => el.userData.placement === "front");
        frontCornerTable.position.x = POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current];
        frontCornerTable.position.z =
            POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current] +
            POSITIONS_MAPS.ostrovPlacementMapPos.front.z;
    } else if (placement === "back") {
        const sideInput = document.querySelector('input[name="corner_table_side__table_back"]:checked') || null;
        const side = sideInput?.value || "right";
        const backCornerTable = servObj.activeCornerTable.find((el) => el.userData.placement === "back");
        backCornerTable.position.x = POSITIONS_MAPS.cornerTableMapPos[side].x[servObj.tableSize.tableWidth.current];
        backCornerTable.position.z =
            -POSITIONS_MAPS.cornerTableMapPos[side].z[servObj.tableSize.tableDepth.current] +
            POSITIONS_MAPS.ostrovPlacementMapPos.back.z;
    }
};

// НИЖНИЕ ЭЛЕМЕНТЫ НИЖНИЕ ЭЛЕМЕНТЫ НИЖНИЕ ЭЛЕМЕНТЫ НИЖНИЕ ЭЛЕМЕНТЫ НИЖНИЕ ЭЛЕМЕНТЫ
export const changeShelfDown = (value, isChecked, placement = null) => {
    const [type, size] = value.split("_");
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const dspTitle = document.getElementById("polka_dsp_title");
    const metallTitle = document.getElementById("polka_metall_title");
    dspTitle?.classList.toggle("active", isChecked && type === "dsp");
    metallTitle?.classList.toggle("active", isChecked && type === "metall");
    const visibleChildren =
        type === "dsp" && servObj.activeShelfDownSide.length
            ? servObj.activeShelfDownSide[0].userData.visibleChildren
            : [];

    const tableDepth = servObj.tableSize.tableDepth.current;

    const zMap = {
        700: {
            dsp: {
                300: {
                    back: 0,
                    front: 0.739,
                },
                400: {
                    back: 0,
                    front: 0.739,
                },
            },
            metall: {
                400: {
                    back: 0,
                    front: 0.19,
                },
                500: {
                    back: 0,
                    front: 0.093,
                },
            },
        },
        900: {
            dsp: {
                300: {
                    back: 0,
                    front: 0.939,
                },
                400: {
                    back: 0,
                    front: 0.939,
                },
            },
            metall: {
                400: {
                    back: 0,
                    front: 0.39,
                },
                500: {
                    back: 0,
                    front: 0.29,
                },
            },
        },
    };

    const sidesWrap = document.querySelector(`.polka_${type}__side__wrap`);
    const config = zMap[tableDepth]?.[type]?.[size];

    const side = config
        ? (sidesWrap?.querySelector(`input[name='polka_${type}__side']:checked`)?.value ?? "back")
        : "back";

    const zPos = config?.[side] ?? 0;
    const zScale = side === "front" && type === "dsp" ? -1 : 1;

    if (!isOstrov) {
        const name = `polka_nizhnyaya__${type}__${servObj.tableSize.tableWidth.current}x${size}`;
        toggleSingleSceneObject({
            allObjects: servObj.allShelfDownSide,
            activeArray: servObj.activeShelfDownSide,
            name,
            isChecked,
            filterActiveFn: () => {},
            position: {
                y: 10,
                z: zPos,
            },
            scale: {
                z: zScale,
            },
            userData: {
                type,
                size,
                position: "bottom",
                visibleChildren,
                side,
            },
            hideChildrenName: ["razdelitel"],
            excludes: ["ostrov"],
        });
        visibleChildren.length && showHideChildrenByNames(servObj.activeShelfDownSide[0], visibleChildren, true);
    } else {
        if (type === "metall") {
            const name = `polka_nizhnyaya__${type}__${servObj.tableSize.tableWidth.current}x${size}`;
            if (placement === null) {
                console.warn(
                    `Не передан placement для металлической полки (передний / задний стол). placement = ${placement}`,
                );
                return;
            }

            // Снимаем все чеки с ДСП вручную, т.к. в этом случае у металлических полок и полок ДСП разный name-аттрибут
            const allInputsDsp = document.querySelectorAll("input[name='polka_depth']");
            allInputsDsp.forEach((inputDsp) => {
                if (inputDsp.checked) {
                    inputDsp.checked = false;
                    hideAndRemoveInArr(servObj.activeShelfDownSide);
                }
            });
            if (placement === "front") {
                toggleSceneObject({
                    allObjects: servObj.allShelfDownSide,
                    activeArray: servObj.activeShelfDownSide,
                    name,
                    isChecked,
                    filterActiveFn: (el) => {
                        if (el.userData.placement === "front") {
                            hideAndRemove(el); // Удаляем объект со сцены
                            return false; // Исключаем из массива
                        }
                        return true;
                    },
                    position: {
                        y: 10,
                        z: POSITIONS_MAPS.ostrovPlacementMapPos.front.z,
                    },
                    userData: {
                        type: type,
                        size,
                        position: "bottom",
                        placement: "front",
                        value,
                    },
                    hideChildrenName: ["razdelitel"],
                });
            } else if (placement === "back") {
                toggleSceneObject({
                    allObjects: servObj.allShelfDownSide,
                    activeArray: servObj.activeShelfDownSide,
                    name,
                    isChecked,
                    filterActiveFn: (el) => {
                        if (el.userData.placement === "back") {
                            hideAndRemove(el); // Удаляем объект со сцены
                            return false; // Исключаем из массива
                        }
                        return true;
                    },
                    position: {
                        y: 10,
                        z: POSITIONS_MAPS.ostrovPlacementMapPos.back.z,
                    },
                    userData: {
                        type: type,
                        size,
                        position: "bottom",
                        placement: "back",
                        value,
                    },
                    hideChildrenName: ["razdelitel"],
                });
            }
        } else {
            const name = `ostrov__polka_nizhnyaya__${type}__${servObj.tableSize.tableWidth.current}x${size}`;

            // Снимаем все чеки с металлических полок вручную, т.к. в этом случае у металлических полок и полок ДСП разный name-аттрибут
            const allInputsMetall = document.querySelectorAll(
                "input[name='polka_depth__table_back'], input[name='polka_depth__table_front']",
            );
            allInputsMetall.forEach((inputMetall) => {
                inputMetall.checked = false;
            });
            toggleSingleSceneObject({
                allObjects: servObj.allShelfDownSide,
                activeArray: servObj.activeShelfDownSide,
                name,
                isChecked,
                filterActiveFn: () => {},
                position: {
                    y: 10,
                },
                userData: {
                    type,
                    size,
                    position: "bottom",
                    name,
                },
                hideChildrenName: ["razdelitel"],
            });
        }
    }
};
export const changeTableAnnex = (type, value, isChecked) => {
    const name = `bokovaya_pristavka__${type}__${value}__${servObj.tableSize.tableDepth.current}`;
    toggleSceneObject({
        allObjects: servObj.allTableAnnex,
        activeArray: servObj.activeTableAnnex,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.type === type && el.userData.value === value) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: 10,
            x: POSITIONS_MAPS.annexMapPos[value].x[servObj.tableSize.tableWidth.current],
        },
        userData: {
            type,
            value,
            position: "bottom",
        },
    });
};
export const changeTableTumba = (side, value, isChecked, placement = null) => {
    const depth = servObj.tableSize.tableDepth.current;
    const name = `tumba_podvesnaya__${value}__${side}__${depth}`;
    const arrMap = {
        left: {
            all: servObj.allTumbaLeft,
            active: servObj.activeTumbaLeft,
        },
        right: {
            all: servObj.allTumbaRight,
            active: servObj.activeTumbaRight,
        },
    };

    const object = servObj.redactorModeObject;

    // Проверяем, нужно ли применять смещение для KSM объектов
    const isKSMTable = object.name.includes("ksm") && object.userData.loadData.folderName === "tables";

    // Определяем смещение для KSM по стороне
    const ksmOffset = isKSMTable && value === "1" ? (side === "left" ? -0.1 : 0.1) : 0;

    // Получаем позицию с учётом смещения
    const xPos = POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current] + ksmOffset;

    let visibleChildren = side === "right" ? ["key_right"] : ["key_left"];
    if (placement === "back") visibleChildren = side === "right" ? ["key_left"] : ["key_right"];

    if (!servObj.redactorModeObject.name.includes("ostrov")) {
        toggleSingleSceneObject({
            allObjects: arrMap[side].all,
            activeArray: arrMap[side].active,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.name.includes(side)) {
                    hideAndRemove(el);
                }
                return !el.name.includes(side);
            },
            position: {
                y: 10,
                x: xPos,
            },
            userData: {
                type: value,
                position: "bottom",
                visibleChildren,
            },
            hideChildrenName: ["key"],
        });
    } else {
        if (placement === null) return;
        const filterActiveFn = (el) => {
            if (el.name.includes(side) && el.userData.placement === placement) {
                hideAndRemove(el);
            }
            return !(el.name.includes(side) && el.userData.placement === placement);
        };
        toggleSceneObject({
            allObjects: arrMap[side].all,
            activeArray: arrMap[side].active,
            name,
            isChecked,
            filterActiveFn,
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: POSITIONS_MAPS.ostrovPlacementMapPos[placement].z,
            },
            userData: {
                type: value,
                position: "bottom",
                placement,
                visibleChildren,
            },
            hideChildrenName: ["key"],
        });
    }
};
export const changePodstavkaPodSistemniiBlok = (value, isChecked, targetSide = "right", placement = null) => {
    const sideInput = document.querySelector('input[name="podstavka_pod_sistemnii_blok_side"]:checked') || null;
    const side = targetSide || sideInput?.value || "right";

    const tempName = "podstavka_pod_sistemnii_blok";
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const name = value === "podkatnaya" ? `${tempName}__right__${value}` : `${tempName}__${side}__${value}`;
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");

    if (!isOstrov) {
        const isVerstak = servObj.redactorModeObject.name.includes("verstak");
        const isVerstakCategory = servObj.redactorModeObject.userData.loadData.folderName === "verstaki";
        const isSMK = servObj.redactorModeObject.name.includes("smk");

        const get_x_pos = () => {
            if (!isVerstak) return 0;
            const isLeftTumba = servObj.activeVerstakTumbaLeft.length > 0;
            const isRightTumba = servObj.activeVerstakTumbaRight.length > 0;
            switch (width) {
                case 1200:
                    if (isRightTumba) return -0.75;
                    if (isLeftTumba) return 0;
                    return 0;
                case 1500:
                    if (isRightTumba && !isLeftTumba) return -0.9;
                    if (isLeftTumba && !isRightTumba) return 0.085;
                    if (isLeftTumba && isRightTumba) return -0.38;
                    return 0;
                case 1800:
                    if (isRightTumba && !isLeftTumba) return -0.9;
                    if (isLeftTumba && !isRightTumba) return 0.085;
                    if (isLeftTumba && isRightTumba) return -0.38;
                    return 0;
                default:
                    return 0;
            }
        };

        const get_z_pos = () => {
            if (isVerstak) return -0.1;
            if (isSMK) return -0.2;
            else if (depth === 500) return -0.14;
            else return 0;
        };

        const xPosVerstak = get_x_pos();
        const xPosDefault =
            POSITIONS_MAPS.podstavkaPodSistemniiBlokMapPos[side].x[servObj.tableSize.tableWidth.current];
        const xPos = isVerstak && value === "podkatnaya" ? xPosVerstak : xPosDefault;
        const zPos = get_z_pos();
        let yPos = 10; // значение по умолчанию

        if (value === "podvesnaya") {
            if (isSMK) {
                yPos = 9.937;
            } else if (isVerstakCategory) {
                yPos = 10 - POSITIONS_MAPS.verstakStoleshnitsaOffset.y;
            }
        }

        toggleSingleSceneObject({
            allObjects: servObj.allPodstavkaPodSistemniiBlok,
            activeArray: servObj.activePodstavkaPodSistemniiBlok,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.name.includes(side)) {
                    hideAndRemove(el);
                }
                return !el.name.includes(side);
            },
            position: {
                x: xPos,
                y: yPos,
                z: zPos,
            },
            userData: {
                name,
                type: value,
                position: "bottom",
            },
        });
    } else {
        if (placement === null) return;
        const filterActiveFn = (el) => {
            const boolean = el.userData.placement === placement;
            if (boolean) {
                hideAndRemove(el);
            }
            return !boolean;
        };
        const allObjects = servObj.allPodstavkaPodSistemniiBlok;
        const activeArray = servObj.activePodstavkaPodSistemniiBlok;

        const position = {
            y: 10,
            x: POSITIONS_MAPS.podstavkaPodSistemniiBlokMapPos[side].x[servObj.tableSize.tableWidth.current],
            z: POSITIONS_MAPS.ostrovPlacementMapPos[placement].z,
        };
        const userData = {
            name,
            type: value,
            position: "bottom",
            placement,
        };
        toggleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn,
            position,
            userData,
        });
    }
};
export const changePodstavkaPodSistemniiBlokSide = (side, placement = null) => {
    changePodstavkaPodSistemniiBlok("podvesnaya", true, side, placement);
};
export const changeLotokDlyaProvodov = (isChecked) => {
    const isTableSPB = servObj.tempName.includes("spb__osnovanie");
    const isTableKSM = servObj.tempName.includes("ksm__osnovanie");
    const tempName = isTableSPB ? "spb__lotok_dlya_provodov" : "lotok_dlya_provodov";
    const name = `${tempName}__${servObj.tableSize.tableWidth.current}`;
    const excludes = isTableSPB ? ["ksm__"] : isTableKSM ? ["spb__"] : ["ksm__", "spb__"];
    toggleSingleSceneObject({
        allObjects: servObj.allLotokDlyaProvodov,
        activeArray: servObj.activeLotokDlyaProvodov,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: 10,
        },
        userData: {
            position: "bottom",
        },
        excludes,
    });
};
export const changePodstavkaPodNogi = (isChecked, placement = null) => {
    const name = "podstavka_pod_nogi";
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const isVerstak = servObj.redactorModeObject.name.includes("verstak");
    const allObjects = servObj.allPodstavkaPodNogi;
    const activeArray = servObj.activePodstavkaPodNogi;
    const width = servObj.tableSize.tableWidth.current;
    if (!isOstrov) {
        const get_x_pos = (isVerstak) => {
            if (!isVerstak) return 0;
            const isLeftTumba = servObj.activeVerstakTumbaLeft.length > 0;
            const isRightTumba = servObj.activeVerstakTumbaRight.length > 0;
            switch (width) {
                case 1200:
                    if (isRightTumba) return -0.15;
                    if (isLeftTumba) return 0.3;
                    return 0;
                case 1500:
                    return 0.085;
                case 1800:
                    return 0.1;
                default:
                    return 0;
            }
        };
        const xPos = get_x_pos(isVerstak);
        toggleSingleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn: (el) => el.name.includes(name),
            position: {
                x: xPos,
                y: 10,
            },
            userData: {
                position: "bottom",
            },
        });
    } else {
        if (placement === null) return;
        toggleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn: (el) => el.userData.placement !== placement,
            position: {
                y: 10,
                z: POSITIONS_MAPS.ostrovPlacementMapPos[placement].z,
            },
            userData: {
                position: "bottom",
                placement,
            },
        });
    }
};
export const changeKomplektStoek = (isChecked) => {
    const object = servObj.redactorModeObject;
    const isVerstakVS = object.userData.loadData.folderName === "verstaki" && object.name.includes("verstak__vs");
    const prefix = isVerstakVS ? "verstak__vs__" : "";
    const tempName = "komplekt_stoek";
    const name = `${prefix}${tempName}__${servObj.tableSize.tableWidth.current}`;

    const isVerstak = servObj.redactorModeObject.name.includes("verstak");
    const isRaskroinii = servObj.redactorModeObject.name.includes("raskroinii");
    const isSPR = servObj.redactorModeObject.name.includes("spr__osnovanie");
    const isKomfort = servObj.redactorModeObject.name.includes("komfort__osnovanie");
    const isKomplektKST = isVerstak;
    const calcNameKST = "komplekt_stoek_kst";
    const calcNameSR = "komplekt_stoek_sr";
    const calcName = isKomplektKST ? calcNameKST : isRaskroinii ? calcNameSR : tempName;

    setActiveCalcValue(calcName, isChecked);

    const getVisibleChildren = () => {
        if (isVerstak) {
            return ["verstak__komplekt_stoek__krepleniya"];
        }
        if (isSPR || isKomfort) {
            return [];
        }
        return ["default__komplekt_stoek__krepleniya"];
    };

    const visibleChildren = getVisibleChildren();

    if (isChecked) setUpViewPort();
    toggleSingleSceneObject({
        allObjects: servObj.allKomplektStoek,
        activeArray: servObj.activeKomplektStoek,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: 10,
        },
        hideChildrenName: ["krepleniya"],
        userData: { visibleChildren },
        ...(isVerstakVS ? {} : { excludes: ["verstak__vs"] }),
    });
};
export const changePolkaKantsPrinadlezhnostei = (value, isChecked, placement = null) => {
    const tempName = "polka_dlya_kantselyarskikh_prinadlezhnostei";
    const name = `${tempName}__${value}`;
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const allObjects = servObj.allPolkaDlyaKantselyarskikhPrinadlezhnostei;
    const activeArray = servObj.activePolkaDlyaKantselyarskikhPrinadlezhnostei;
    if (!isOstrov) {
        toggleSingleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn: (el) => el.name.includes(name),
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[value].x[servObj.tableSize.tableWidth.current],
                z: POSITIONS_MAPS.annexMapPos[value].z[servObj.tableSize.tableDepth.current],
            },
        });
    } else {
        if (placement === null) return;
        const filterActiveFn = (el) => {
            const boolean = el.userData.placement === placement;
            if (boolean) {
                hideAndRemove(el);
            }
            return !boolean;
        };
        const posZ = () => {
            const { z } = POSITIONS_MAPS.annexMapPos[value];
            const depth = servObj.tableSize.tableDepth.current;
            const placementMap = POSITIONS_MAPS.ostrovPlacementMapPos[placement]?.z;
            return placement === "front" ? z[depth] + placementMap : -z[depth] + placementMap;
        };
        toggleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn,
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[value].x[servObj.tableSize.tableWidth.current],
                z: posZ(),
            },
            userData: {
                placement,
                side: value,
            },
        });
    }
};
export const changePolkaDlyaKlaviatury = (value, isChecked, targerSide = null, placement = null) => {
    "polka_dlya_klaviaturi__left__metall";

    const tempName = "polka_dlya_klaviaturi";
    const sideInput = document.querySelector('input[name="polka_dlya_klaviaturi_side"]:checked') || null;
    const side = targerSide || sideInput?.value || "right";
    const name = `${tempName}__${side}__${value}`;
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const isVerstak = servObj.redactorModeObject.name.includes("verstak");
    const isVerstakCategory = servObj.redactorModeObject.userData.loadData.folderName === "verstaki";

    if (!isOstrov) {
        const sideWrap = document.querySelector(".polka_dlya_klaviaturi_side_wrap");
        sideWrap.querySelector(`input[name="polka_dlya_klaviaturi_side"][value="${side}"]`).checked = true;
        const xPos = isVerstak
            ? POSITIONS_MAPS.verstak.polka_dlya_klaviaturi[side].x[servObj.tableSize.tableWidth.current]
            : POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current];
        const zPos = isVerstak
            ? POSITIONS_MAPS.verstak.polka_dlya_klaviaturi[side].z[servObj.tableSize.tableDepth.current]
            : POSITIONS_MAPS.annexMapPos[side].z[servObj.tableSize.tableDepth.current];

        let yPos = 10; // значение по умолчанию

        if (isVerstakCategory) {
            yPos = 10 - POSITIONS_MAPS.verstakStoleshnitsaOffset.y;
        } else if (isVerstak) {
            yPos = 9.997;
        }

        toggleSingleSceneObject({
            allObjects: servObj.allPolkaDlyaKlaviaturi,
            activeArray: servObj.activePolkaDlyaKlaviaturi,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.name.includes(side)) {
                    hideAndRemove(el);
                }
                return !el.name.includes(side);
            },
            position: {
                y: yPos,
                x: xPos,
                z: zPos,
            },
            userData: {
                type: value,
            },
        });

        // Если чекбокс не отмечен и нет активных объектов, то снимает "галочку" с выбора стороны
        if (!isChecked && servObj.activePolkaDlyaKlaviaturi.length === 0) {
            document.querySelectorAll('input[name="polka_dlya_klaviaturi_side"]').forEach((el) => {
                el.checked = false;
            });
        }
    } else {
        if (placement === null) return;
        const sideWrap = document.querySelector(`.polka_dlya_klaviaturi_side_wrap__table_${placement}`);
        sideWrap.querySelector(
            `input[name="polka_dlya_klaviaturi_side__table_${placement}"][value="${side}"]`,
        ).checked = true;
        const filterActiveFn = (el) => {
            const boolean = el.userData.placement === placement;
            if (boolean) {
                hideAndRemove(el);
            }
            return !boolean;
        };
        const posZ = () => {
            const { z } = POSITIONS_MAPS.annexMapPos[side];
            const depth = servObj.tableSize.tableDepth.current;
            const placementMap = POSITIONS_MAPS.ostrovPlacementMapPos[placement]?.z;
            return placement === "front" ? z[depth] + placementMap : -z[depth] + placementMap;
        };
        toggleSceneObject({
            allObjects: servObj.allPolkaDlyaKlaviaturi,
            activeArray: servObj.activePolkaDlyaKlaviaturi,
            name,
            isChecked,
            filterActiveFn,
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: posZ(),
            },
            userData: {
                type: value,
                placement,
                side,
            },
        });

        // Если чекбокс не отмечен и нет активных объектов, то снимает "галочку" с выбора стороны
        if (!isChecked && servObj.activePolkaDlyaKlaviaturi.length === 0) {
            document.querySelectorAll(`input[name="polka_dlya_klaviaturi_side__table_${placement}"]`).forEach((el) => {
                el.checked = false;
            });
        }
    }
};
export const changePolkaDlyaKlaviaturySide = (side, placement = null) => {
    if (servObj.activePolkaDlyaKlaviaturi.length) {
        const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
        const type = isOstrov
            ? servObj.activePolkaDlyaKlaviaturi.find((el) => el.userData.placement === placement).userData.type
            : servObj.activePolkaDlyaKlaviaturi[0].userData.type;
        changePolkaDlyaKlaviatury(type, true, side, placement);
    }
};
export const changeShelfEquipment = (side, isChecked, placement = null) => {
    const tempName = "polka_vidvizhnaya_pod_orgtekhniku";
    const name = `${tempName}__${side}`;
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const isVerstak = servObj.redactorModeObject.name.includes("verstak");
    const allObjects = servObj.allPolkaVidvizhnayaPodOrgtekhniku;
    const activeArray = servObj.activePolkaVidvizhnayaPodOrgtekhniku;
    if (!isOstrov) {
        toggleSingleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn: () => {},
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: isVerstak ? -0.12 : POSITIONS_MAPS.annexMapPos[side].z[servObj.tableSize.tableDepth.current],
            },
            userData: {
                type: side,
            },
        });
    } else {
        if (placement === null) return;
        const filterActiveFn = (el) => {
            const boolean = el.userData.placement === placement;
            if (boolean) {
                hideAndRemove(el);
            }
            return !boolean;
        };
        const posZ = () => {
            const { z } = POSITIONS_MAPS.annexMapPos[side];
            const depth = servObj.tableSize.tableDepth.current;
            const placementMap = POSITIONS_MAPS.ostrovPlacementMapPos[placement]?.z;
            return placement === "front" ? z[depth] + placementMap : -z[depth] + placementMap;
        };
        toggleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn,
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: posZ(),
            },
            userData: {
                type: side,
                placement,
            },
        });
    }
};
export const changeKontainerDlyaRabochikhOtkhodov = (side, isChecked, placement = null) => {
    const tempName = "konteiner_dlya_rabochikh_otkhodov";
    const name = `${tempName}__${side}`;
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const allObjects = servObj.allKonteinerDlyaRabochikhOtkhodov;
    const activeArray = servObj.activeKonteinerDlyaRabochikhOtkhodov;
    if (!isOstrov) {
        toggleSingleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn: () => {},
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
            },
            userData: {
                type: side,
                position: "bottom",
            },
        });
    } else {
        if (placement === null) return;
        const filterActiveFn = (el) => {
            const boolean = el.userData.placement === placement;
            if (boolean) {
                hideAndRemove(el);
            }
            return !boolean;
        };
        toggleSceneObject({
            allObjects,
            activeArray,
            name,
            isChecked,
            filterActiveFn,
            position: {
                y: 10,
                x: POSITIONS_MAPS.annexMapPos[side].x[servObj.tableSize.tableWidth.current],
                z: POSITIONS_MAPS.ostrovPlacementMapPos[placement].z,
            },
            userData: {
                type: side,
                position: "bottom",
                placement,
            },
        });
    }
};
export const changeRazdeliteli = (count) => {
    const name = "razdelitel__polka_nizhnyaya__dsp";
    const elName = "polka_nizhnyaya__dsp";
    const polka = servObj.activeShelfDownSide.filter((el) => el.name.includes(elName));
    const filterFn = (el) => !el.includes(name);
    if (polka.length) {
        if (count < 5) {
            polka.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
        } else {
            polka.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
            polka[0].userData.visibleChildren.push(name);
            showHideChildrenByNames(polka[0], [name], true);
        }
    }
};
export const changeYashchikMKPlastik = (value, isChecked) => {
    const tempName = "yashchik_dlya_melkikh_komplektuyushchikh__plastik";
    const name = `${tempName}__${value}`;
    toggleSingleSceneObject({
        allObjects: servObj.allYashchikMKPlastik,
        activeArray: servObj.activeYashchikMKPlastik,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: 10,
            x: POSITIONS_MAPS.annexMapPos[value].x[servObj.tableSize.tableWidth.current],
            z: POSITIONS_MAPS.annexMapPos[value].z[servObj.tableSize.tableDepth.current],
        },
    });
};
export const changeYashchikMKMetall = (value, isChecked) => {
    const tempName = "yashchik_dlya_melkikh_komplektuyushchikh__metall";
    const name = `${tempName}__${value}`;
    toggleSingleSceneObject({
        allObjects: servObj.allYashchikMKMetall,
        activeArray: servObj.activeYashchikMKMetall,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: 10,
            x: POSITIONS_MAPS.annexMapPos[value].x[servObj.tableSize.tableWidth.current],
            z: POSITIONS_MAPS.annexMapPos[value].z[servObj.tableSize.tableDepth.current],
        },
    });
};
export const changeDerzhatelRulonaNizhnii = (isChecked, side = "back") => {
    const name = `derzhatel_rulona__nizhnii__${servObj.tableSize.tableWidth.current}`;
    const visibleChildren = servObj.activeDerzhatelRulonaNizhnii.length
        ? servObj.activeDerzhatelRulonaNizhnii[0].userData.visibleChildren
        : [];

    const zPosMap = {
        front: {
            700: 0.35,
            900: 0.55,
        },
        back: {
            700: 0,
            900: 0,
        },
    };
    const depth = servObj.tableSize.tableDepth.current;
    const zPos = zPosMap[side][depth];

    toggleSingleSceneObject({
        allObjects: servObj.allDerzhatelRulonaNizhnii,
        activeArray: servObj.activeDerzhatelRulonaNizhnii,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: 10,
            z: zPos,
        },
        userData: {
            visibleChildren,
            side,
        },
        hideChildrenName: ["fiksatori"],
    });
};
export const changeBokovieFiksatoriRulonaNizhnii = (isChecked) => {
    const name = "bokovie_fiksatori_rulona__nizhnii";
    const elName = "derzhatel_rulona__nizhnii";
    const derzhatel = servObj.activeDerzhatelRulonaNizhnii.filter((el) => el.name.includes(elName));
    const filterFn = (el) => !el.includes(name);
    if (derzhatel.length) {
        if (!isChecked) {
            derzhatel.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
        } else {
            derzhatel.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
            derzhatel[0].userData.visibleChildren.push(name);
            showHideChildrenByNames(derzhatel[0], [name], true);
        }
    }
};
export const changeVarstakStoleshnitsa = (isChecked = true) => {
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const tempName = `verstak__stoleshnitsa__${width}x${depth}`;
    toggleSingleSceneObject({
        allObjects: servObj.allVerstakStoleshnitsa,
        activeArray: servObj.activeVerstakStoleshnitsa,
        name: tempName,
        isChecked: isChecked,
        filterActiveFn: () => {},
        position: {
            x: 0,
            y: 10,
            z: 0,
        },
    });
};
export const changeVarstakTumba = (value, side, isChecked = true) => {
    const tempName = value;
    const width = Number(servObj.tableSize.tableWidth.current);
    const pos_x_map = {
        1200: 0,
        1500: 0.15,
        1800: 0.3,
    };
    const posX = pos_x_map[width] * (side === "left" ? -1 : 1);
    const allArr = side === "right" ? servObj["allVerstakTumbaRight"] : servObj["allVerstakTumbaLeft"];
    const activeArr = side === "right" ? servObj["activeVerstakTumbaRight"] : servObj["activeVerstakTumbaLeft"];
    const activeNizhkiArr = side === "right" ? servObj["activeVerstakNozhkiRight"] : servObj["activeVerstakNozhkiLeft"];
    hideAndRemoveInArr(activeNizhkiArr);
    toggleSingleSceneObject({
        allObjects: allArr,
        activeArray: activeArr,
        name: tempName,
        isChecked: isChecked,
        filterActiveFn: () => {},
        position: {
            x: posX,
            y: 10,
            z: 0,
        },
    });
    let calc_name = "";
    const getTumbaBoxCount = (tumba) => (tumba ? Number(tumba.split("__")[2]) : null);
    const leftTumbaBoxCount = getTumbaBoxCount(servObj.activeVerstakTumbaLeft[0]?.name);
    const rightTumbaBoxCount = getTumbaBoxCount(servObj.activeVerstakTumbaRight[0]?.name);
    if (leftTumbaBoxCount && !rightTumbaBoxCount) {
        calc_name = `verstak_${width}_t${leftTumbaBoxCount}`;
        setActiveCalcValue(calc_name, isChecked);
    } else if (!leftTumbaBoxCount && rightTumbaBoxCount) {
        calc_name = `verstak_${width}_t${rightTumbaBoxCount}`;
        setActiveCalcValue(calc_name, isChecked);
    } else if (leftTumbaBoxCount && rightTumbaBoxCount) {
        calc_name = `verstak_${width}_t${rightTumbaBoxCount}_t${leftTumbaBoxCount}`;
        if (!servObj.calc[calc_name]) {
            calc_name = `verstak_${width}_t${leftTumbaBoxCount}_t${rightTumbaBoxCount}`;
        }
        setActiveCalcValue(calc_name, isChecked);
    }

    //Обновим позицию подставки под ноги при смене тумбы
    if (servObj.activePodstavkaPodNogi.length) {
        changePodstavkaPodNogi(true);
    }
    // if (servObj.activePodstavkaPodSistemniiBlok.length) {
    //     const type = servObj.activePodstavkaPodSistemniiBlok[0]?.userData.type;
    //     changePodstavkaPodSistemniiBlok(type, true);
    // }
};
export const changeVerstakNozhki = (side, isChecked = true) => {
    if (!side) {
        console.warn("[changeVerstakNozhki] Side не определена", side);
        return;
    }
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const tempName = `verstak__nozhki__${width}x${depth}__${side}`;
    const allArr = side === "right" ? servObj["allVerstakNozhkiRight"] : servObj["allVerstakNozhkiLeft"];
    const activeArr = side === "right" ? servObj["activeVerstakNozhkiRight"] : servObj["activeVerstakNozhkiLeft"];
    const activeTumbaArr = side === "right" ? servObj["activeVerstakTumbaRight"] : servObj["activeVerstakTumbaLeft"];
    hideAndRemoveInArr(activeTumbaArr);
    toggleSingleSceneObject({
        allObjects: allArr,
        activeArray: activeArr,
        name: tempName,
        isChecked: isChecked,
        filterActiveFn: () => {},
        position: {
            x: 0,
            y: 10,
            z: 0,
        },
    });
};
export const changeRazdeliteliDownRaskroinii = (count) => {
    const name = "razdelitel__raskroinii__osnovanie";
    const table = servObj.redactorModeObject;

    // Создадим поле visibleChildren, если его нет
    if (!table.userData.visibleChildren) table.userData.visibleChildren = [];
    const filterFn = (el) => !el.includes(name);
    if (count < 5) {
        showHideChildrenByNames(table, [name], false);
        table.userData.visibleChildren = table.userData.visibleChildren.filter(filterFn);
    } else {
        showHideChildrenByNames(table, [name], false);
        table.userData.visibleChildren = table.userData.visibleChildren.filter(filterFn);
        table.userData.visibleChildren.push(name);
        showHideChildrenByNames(table, [name], true);
    }
};
export const changeVerstakPerekladini = (isChecked) => {
    const { tempName, tableSize, redactorModeObject } = servObj;
    const tableWidth = tableSize.tableWidth.current;
    const tableDepth = tableSize.tableDepth.current;
    const isVerstakCategory = redactorModeObject.userData.loadData.folderName === "verstaki";

    const name = `verstak__${isVerstakCategory ? `${tempName}__` : ""}perekladini_dlya_krepleniya_tumb__${tableWidth}x${tableDepth}`;

    toggleSingleSceneObject({
        allObjects: servObj.allVerstakPerekladini,
        activeArray: servObj.activeVerstakPerekladini,
        name,
        filterActiveFn: (el) => el.name !== name,
        isChecked,
        position: { y: 10 },
        userData: { name },
    });
};
